/**
 * @module voyager/ng/view
 */
import { on, off, addClass, remove, append, after, cloneNode, isUndefined } from '@acng/frontend-bounty';
import { getViewPort } from '../view';
export const onswViewComponent = {
    // TODO deprecated tranclude "element"
    // @ts-expect-error type library sucks.
    transclude: 'element',
    controller,
};
controller.$inject = ['$element', '$attrs', '$transclude', '$compile'];
function controller($element, $attrs, $transclude, $compile) {
    let previousScope;
    let previousClone;
    const element = $element[0];
    const name = $attrs.name;
    const viewPort = getViewPort(name);
    const VERBOSE = !isUndefined($attrs['debug']);
    const leave = () => {
        remove(previousClone);
        if (previousScope) {
            previousScope.$destroy();
        }
        previousScope = previousClone = undefined;
    };
    const update = (viewPort) => {
        DEBUG: VERBOSE && console.debug(`voyager/ng/view "${name}" update`, { viewPort });
        const content = viewPort.content;
        leave();
        if (!content) {
            return;
        }
        $transclude(($clone, $scope) => {
            if (!$clone || !$scope) {
                throw new Error('something went wrong');
            }
            const clone = $clone[0];
            addClass(clone, ...viewPort.tokens);
            after(element, clone);
            append(clone, cloneNode(content.content));
            // @ts-expect-error type library sucks. angularjs accepts HTMLCollection
            $compile(clone.children)($scope);
            $scope.$digest();
            previousClone = clone;
            previousScope = $scope;
        });
    };
    const listener = (evt) => {
        DEBUG: VERBOSE && console.debug(`voyager/ng/view "${name}" listener`, { evt });
        update(evt.detail);
    };
    DEBUG: VERBOSE && console.debug(`voyager/ng/view "${name}" constructor`, { viewPort });
    if (viewPort.content) {
        update(viewPort);
    }
    on(viewPort, 'content', listener);
    this.$onDestroy = () => off(viewPort, 'content', listener);
}
